"use strict";

var _useViewerAccountQuery;
import { c as _c } from "react/compiler-runtime";
import { graphql, useLazyLoadQuery } from 'react-relay/hooks';
export const useViewerAccount = () => {
  const $ = _c(3);
  let t0;
  let t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = _useViewerAccountQuery !== void 0 ? _useViewerAccountQuery : _useViewerAccountQuery = require("../relay/__generated__/useViewerAccountQuery.graphql");
    t1 = {};
    t2 = {
      fetchPolicy: "store-or-network"
    };
    $[0] = t0;
    $[1] = t1;
    $[2] = t2;
  } else {
    t0 = $[0];
    t1 = $[1];
    t2 = $[2];
  }
  const {
    viewer
  } = useLazyLoadQuery(t0, t1, t2);
  return viewer;
};